import React, { useEffect, useState, Suspense, } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import Button from '@mui/material/Button';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DownloadIcon from '@mui/icons-material/Download';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Member from "./Manage/Member";
import AddMember from "./Manage/AddMember";
import FollowMember from "./Manage/FollowMember";
import AddHistory from "./Manage/AddHistory";
import HistoryDetail from "./Manage/HistoryDetail";
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { message } from 'antd';
import {
  setFile, getFile, getStyle, setObjective, setObjectiveCheck, getBizID, setMemberSuccess, setMemberFail, getRoles,
  setStepRedux, getStepRedux, getCurrentRole, getServices,getObjectiveCheck
} from '../libs/todoSlice'
import LoadingComponent from '../lib/LoadingComponent';
import fontColor from '../lib/fontColor';
import { getImportModal, getManageMemberStep, setImportModal, setManageMemberStep } from '../libs/sideBarSlice';
import ExcelImport from './Excel/ExcelImport';
// import Radio from '@mui/material/Radio';
import ExcelImportPreRegister from './Excel/ExcelImportPreRegister';
import ExcelImportPreRegisterEduStudent from './Excel/ExcelImportPreRegisterEduStudent';
import ExcelImportPreRegisterEduTeacher from './Excel/ExcelImportPreRegisterEduTeacher';
import ExcelImportRama from './Excel/ExcelImportRama';
// import { margin } from '@mui/system';
import axios from 'axios';
import ExcelImportPreRegisterEduOfficer from './Excel/ExcelImportPreRegisterEduOfficer';
import { setFormTypeRedux } from "../libs/eduPortalManagementSlice";
import ReNewCA  from './Manage/ReNewCA'; 
function ManageMember() {
  function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }
  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,

  };
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const currentRole = useSelector(getCurrentRole)
  const file = useSelector(getFile)
  const style = useSelector(getStyle)
  const biz_id = useSelector(getBizID)
  const [value, setValue] = useState('1');
  const open = useSelector(getImportModal)
  const hiddenIdCard = process.env.REACT_APP_HIDDEN_ID_CARD;
  const listIdCardCheck = hiddenIdCard ? JSON.parse(hiddenIdCard) : [];
  const setOpen = (action) => {
    dispatch(setImportModal({
      importModal: action
    }))
  }

  const step = useSelector(getManageMemberStep)
  const setStep = (name) => {
    dispatch(setManageMemberStep({
      manageMemberStep: name
    }))
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    dispatch(setFile({
      file: [],
      filename: '',
      file_id: ''
    }))
    dispatch(setObjective({
      objective: services.includes('one-id') || services.includes('one-id-pmuc') ? ['One ID'] : ['']
    }))
    setFormName(services.includes('one-id') || services.includes('one-id-pmuc') ? ['One ID'] : [''])
    dispatch(setObjectiveCheck({
      objective_check: ['user']
    }))
    setCheckName(['user'])
  };

  const services = useSelector(getServices)

  useEffect(() => {
    const safeServices = Array.isArray(services) ? services : []

    if (!currentRole) return

    const isManagementAllowedRole = currentRole === 'RA' || currentRole === 'owner'
    if (!isManagementAllowedRole) {
      if (safeServices.includes('digital-workflow')) {
        navigate(`/${params.prefix}/services/digital-workflow`)
      } else {
        navigate(`/${params.prefix}/home`)
      }
    }
  }, [currentRole, services, params.prefix, navigate])

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
      background: 'transparent',
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
      background: 'transparent',
    },
  }));

  const downloadExcel = async () => {
    let url = `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel/export?business_id=${biz_id}`
    //hidden cid column if this biz have config
    if(listIdCardCheck.includes(biz_id)){
      url = url + `&hidden_cid=t`
    }
    await axios({
      method: 'GET',
      url: url,
    }).then(({ data, status }) => {
      const base64String = data.data
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const date = new Date();
      link.download = biz_id + "_" + date.getDate() + "-" + date.getMonth() + "-" + date.getFullYear() + '.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, ({ response, status }) => {
    })
  }


  const [formName, setFormName] = useState(services.includes('one-id') || services.includes('one-id-pmuc') ? ['One ID'] : ['']);
  const manageImport = () => {
    if (formName.includes('Pre-register')) {
      return (
        <Suspense fallback={<LoadingComponent />}>
          <ExcelImportPreRegister />
        </Suspense>
      )
    }
    else if (formName.includes('edu-student-pre-register')) {
      return (
        <Suspense fallback={<LoadingComponent />}>
          <ExcelImportPreRegisterEduStudent />
        </Suspense>
      )
    }
    else if (formName.includes('edu-officer-pre-register')) {
      return (
        <Suspense fallback={<LoadingComponent />}>
          <ExcelImportPreRegisterEduOfficer />
        </Suspense>
      )
    }
    else if (formName.includes('edu-teacher-pre-register')) {
      return (
        <Suspense fallback={<LoadingComponent />}>
          <ExcelImportPreRegisterEduTeacher />
        </Suspense>
      )
    }
    else if (formName.includes('import-excel-rama')) {
      return (
        <Suspense fallback={<LoadingComponent />}>
          <ExcelImportRama />
        </Suspense>
      )
    }
    else {
      return (
        <Suspense fallback={<LoadingComponent />}>
          <ExcelImport />
        </Suspense>
      )
    }
  }

  const chipLabel = (value) => {
    switch (value) {
      case 'import-excel-rama':
        return 'CA'
      case 'one-id':
      case 'one-id-pmuc':
        return 'One ID'
      default:
        return value
    }
  }

  const manageDropdown = () => {
    const list = [
      {
        show: services.includes('one-id'),
        element: (
          <MenuItem
            style={{
              pointerEvents: 'none',
            }}
            value='one-id'
          >
            <Checkbox
              checked={true}
              disabled={true}
            />
            <ListItemText primary='One ID' />
          </MenuItem>
        )
      },
      {
        show: services.includes('one-id-pmuc'),
        element: (
          <MenuItem
            style={{
              pointerEvents: 'none',
            }}
            value='one-id-pmuc'
          >
            <Checkbox
              checked={true}
              disabled={true}
            />
            <ListItemText primary='One ID' />
          </MenuItem>
        )
      },
      {
        show: services.includes('ca') && !checkName.includes('ra') ,
        element: (
          <MenuItem
            style={{
              pointerEvents: (formName.includes('import-excel-rama') || formName.includes('Pre-register') || formName.includes('edu-student-pre-register') || formName.includes('edu-officer-pre-register') || formName.includes('edu-teacher-pre-register')) ? 'none' : 'auto',
            }}
            value='CA'
          >
            <Checkbox
              checked={formName.includes('CA')}
              disabled={(formName.includes('import-excel-rama') || formName.includes('Pre-register') || formName.includes('edu-student-pre-register') || formName.includes('edu-teacher-pre-register')) || formName.includes('edu-officer-pre-register')}
            />
            <ListItemText primary='CA' />
          </MenuItem>
        )
      },
      {
        show: services.includes('import-excel-rama'),
        element: (
          <MenuItem
            style={{
              pointerEvents: (formName.includes('เลขที่หนังสือสัญญา') || formName.includes('CA') || formName.includes('Pre-register') || formName.includes('edu-student-pre-register') || formName.includes('edu-officer-pre-register') || formName.includes('edu-teacher-pre-register')) ? 'none' : 'auto',
            }}
            value='import-excel-rama'
          >
            <Checkbox
              checked={formName.includes('import-excel-rama')}
              disabled={formName.includes('เลขที่หนังสือสัญญา') || formName.includes('CA') || (formName.includes('Pre-register') || formName.includes('edu-student-pre-register') || formName.includes('edu-teacher-pre-register')) || formName.includes('edu-officer-pre-register')}
            />
            <ListItemText primary='CA' />
          </MenuItem>
        )
      },
      {
        show: services.includes('contract-no') ,
        element: (
          <MenuItem
            style={{
              pointerEvents: formName.includes('import-excel-rama') || (formName.includes('Pre-register') || formName.includes('edu-student-pre-register') || formName.includes('edu-officer-pre-register') || formName.includes('edu-teacher-pre-register')) ? 'none' : 'auto',
            }}
            value='เลขที่หนังสือสัญญา'
          >
            <Checkbox
              checked={formName.includes('เลขที่หนังสือสัญญา')}
              disabled={formName.includes('import-excel-rama') || (formName.includes('Pre-register') || formName.includes('edu-student-pre-register') || formName.includes('edu-teacher-pre-register')) || formName.includes('edu-officer-pre-register')}
            />
            <ListItemText primary='เลขที่หนังสือสัญญา' />
          </MenuItem>)
      },
      // {
      //   show: services.includes('edu-student-pre-register'),
      //   element: (
      //     <MenuItem
      //       style={{
      //         pointerEvents: formName.includes('Pre-register') || formName.includes('import-excel-rama') || formName.includes('CA') || formName.includes('เลขที่หนังสือสัญญา') || formName.includes('Pre-regis') || formName.includes('edu-officer-pre-register') || formName.includes('edu-teacher-pre-register') ? 'none' : 'auto',
      //       }}
      //       value='edu-student-pre-register'
      //     >
      //       <Checkbox
      //         checked={formName.includes('edu-student-pre-register')}
      //         disabled={formName.includes('Pre-register') || formName.includes('import-excel-rama') || formName.includes('CA') || formName.includes('เลขที่หนังสือสัญญา') || formName.includes('Pre-regis') || formName.includes('edu-teacher-pre-register') || formName.includes('edu-officer-pre-register')}
      //       />
      //       <ListItemText primary='Pre-register (สำหรับนักเรียน)' />
      //     </MenuItem>
      //   )
      // },
      // {
      //   show: services.includes('edu-officer-pre-register'),
      //   element: (
      //     <MenuItem
      //       style={{
      //         pointerEvents: formName.includes('Pre-register') || formName.includes('import-excel-rama') || formName.includes('CA') || formName.includes('เลขที่หนังสือสัญญา') || formName.includes('Pre-regis') || formName.includes('edu-student-pre-register') || formName.includes('edu-teacher-pre-register') ? 'none' : 'auto',
      //       }}
      //       value='edu-officer-pre-register'
      //     >
      //       <Checkbox
      //         checked={formName.includes('edu-officer-pre-register')}
      //         disabled={formName.includes('Pre-register') || formName.includes('import-excel-rama') || formName.includes('CA') || formName.includes('เลขที่หนังสือสัญญา') || formName.includes('Pre-regis') || formName.includes('edu-teacher-pre-register') || formName.includes('edu-student-pre-register')}
      //       />
      //       <ListItemText primary='Pre-register (สำหรับบุคคลากร)' />
      //     </MenuItem>
      //   )
      // },
      // {
      //   show: services.includes('edu-teacher-pre-register'),
      //   element: (
      //     <MenuItem
      //       style={{
      //         pointerEvents: formName.includes('Pre-register') || formName.includes('import-excel-rama') || formName.includes('CA') || formName.includes('เลขที่หนังสือสัญญา') || formName.includes('Pre-regis') || formName.includes('edu-officer-pre-register') || formName.includes('edu-student-pre-register') ? 'none' : 'auto',
      //       }}
      //       value='edu-teacher-pre-register'
      //     >
      //       <Checkbox
      //         checked={formName.includes('edu-teacher-pre-register')}
      //         disabled={formName.includes('Pre-register') || formName.includes('import-excel-rama') || formName.includes('CA') || formName.includes('เลขที่หนังสือสัญญา') || formName.includes('Pre-regis') || formName.includes('edu-student-pre-register') || formName.includes('edu-officer-pre-register')}
      //       />
      //       <ListItemText primary='Pre-register (สำหรับครู/อาจารย์)' />
      //     </MenuItem>
      //   )
      // },
      // {
      //   show: services.includes('medical-pre-register'),
      //   element: (
      //     <MenuItem
      //       style={{
      //         pointerEvents: formName.includes('import-excel-rama') || formName.includes('CA') || formName.includes('เลขที่หนังสือสัญญา') || formName.includes('edu-teacher-pre-register') || formName.includes('edu-officer-pre-register') || formName.includes('edu-student-pre-register') ? 'none' : 'auto',
      //       }}
      //       value='Pre-register'
      //     >
      //       <Checkbox
      //         checked={formName.includes('Pre-register')}
      //         disabled={formName.includes('import-excel-rama') || formName.includes('CA') || formName.includes('เลขที่หนังสือสัญญา') || formName.includes('edu-teacher-pre-register') || formName.includes('edu-student-pre-register') || formName.includes('edu-officer-pre-register')}
      //       />
      //       <ListItemText primary='Pre-register (สำหรับแพทย์)' />
      //     </MenuItem>
      //   )
      // },
    ].filter(l => l.show)  

    return (
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label">เลือกรูปแบบ</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          style={{ width: '100%' }}
          multiple
          value={formName}
          onChange={handleChangeSelect}
          input={<OutlinedInput label="เลือกรูปแบบ" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {[...new Set(selected.filter(v => v !== '').map(chipLabel))].map((label) => (
                <Chip key={label} label={label} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {list.map(item => item.element)}
        </Select>
      </FormControl>
    )
  }

  const [checkName, setCheckName] = useState(['user']);
  const manageCheckbox = () => {
    const list = [
        {
          show: true,
          element: (
            <MenuItem value="user">
            <ListItemText primary='User' />
            </MenuItem>
          )
        },
        {
          show: true,
          element: (
            <MenuItem value="ra">
            <ListItemText primary='RA' />
            </MenuItem>
          )
        },
    ].filter(l => l.show)
    return (
      <FormControl sx={{ m: 1, width: 300 }}
        style={{  width: '100%' }}>
        <InputLabel labelId="เลือกรูปแบบการส่งข้อมูล">เลือกรูปแบบการส่งข้อมูล</InputLabel>
        <Select
          labelId="เลือกรูปแบบการส่งข้อมูล"
          label='เลือกรูปแบบการส่งข้อมูล'
          value={checkName}
          onChange={handleChangeSelectCheck}
          style={{
            width: '300px'
          }}
        >
          {list.map(item => item.element)}
        </Select>
      </FormControl>
    )
  }

  const handleChangeSelectCheck = (event) => {
    const {
      target: { value },
    } = event;
      setCheckName(
        typeof value === 'string' ? value.split(',') : value,
      );
  };

  useEffect(() => {
    let newObjective = formName.map((item) => {   
      if (item === 'เลขที่หนังสือสัญญา'){
        return 'เลขที่หนังสือสัญญา';
      }
      if (item === 'CA'){
        return 'CA';
      }
      if (services.includes('one-id-pmuc') ){
        return 'one-id-pmuc';
      }else if (services.includes('one-id')) {
          return 'one-id';
      }   
      return item;
    });
    dispatch(setObjective({
      objective: newObjective
    }))
    dispatch(setFile({
      file: [],
      filename: '',
      file_id: ''
    }))
  }, [formName]);
  
  useEffect(() => {
    dispatch(setObjectiveCheck({
      objective_check: checkName
    }))
    dispatch(setFile({
      file: [],
      filename: '',
      file_id: ''
    }))
  }, [checkName]);

  useEffect(() => {
    dispatch(setFormTypeRedux({ formType: '' }))
    dispatch(setManageMemberStep({ manageMemberStep: 'manage_member' }))
    return () => {
      dispatch(setFile({ file: [], file_id: '', filename: '' }))
      dispatch(setMemberSuccess({ member_success: [] }))
      dispatch(setMemberFail({ member_fail: [] }))
      dispatch(setObjective({ objective: services.includes('one-id') || services.includes('one-id-pmuc') ? ['One ID'] : [''] }))
      dispatch(setObjectiveCheck({ objective_check: ['user'] }))
    }
  }, [])

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const handleChangeSelect = (event) => {
    const {
      target: { value },
    } = event;
    if (value !== 'one-id' && value !== 'one-id-pmuc') {
      setFormName(
        //  !formName.includes(value) ? [...formName, value] : ['One ID', value]
        typeof value === 'string' ? value.split(',') : value,
      );
    }
  };
  return (
    <>
      {
        {
          "manage_member": (
            <>
              <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Col className="d-flex justify-content-start" xs={12} sm={6}>
                  <h3>จัดการสมาชิก</h3>
                </Col>
                <Col className="d-flex justify-content-end" xs={12} sm={6}>
                  {/* <Button variant="outlined" startIcon={<AddIcon />}>
                    เพิ่มพนักงาน
                  </Button> &nbsp;&nbsp;&nbsp; */}
                  {(currentRole === 'RA' || currentRole === 'owner') &&
                    <>
                      <Button
                        // className='btn-upload-excel'
                        variant="contained"
                        startIcon={<DownloadIcon />}
                        onClick={() => {
                          downloadExcel()

                        }}
                        style={{ marginRight: '10px', width: 177 }}
                        sx={!!style.primary_color && {
                          backgroundColor: `${style.secondary_color} !important`,
                          color: fontColor(style.secondary_color)
                        }}>
                        ดาวน์โหลดไฟล์
                      </Button>
                      <Button
                        // className='btn-upload-excel'
                        variant="contained"
                        style={{ width: 177 }}
                        startIcon={<FileUploadIcon />}
                        sx={!!style.primary_color && {
                          backgroundColor: `${style.secondary_color} !important`,
                          color: fontColor(style.secondary_color)
                        }}
                        onClick={handleClickOpen}
                      >
                        อัปโหลดไฟล์ Excel
                      </Button>
                    </>
                  }
                  &nbsp;&nbsp;&nbsp;

                  <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    sx={{
                      background: 'transparent'
                    }}
                  >
                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} style={{ textAlign: 'center' }}>
                      อัปโหลดไฟล์
                    </BootstrapDialogTitle>
                    <DialogContent>
                      <Typography gutterBottom>
                        <Row>
                          <Col className='align-self-center'>
                            เลือกรูปแบบการนำเข้าข้อมูล :
                          </Col>
                          <Col className='align-self-center'>
                            {manageDropdown()}
                          </Col>
                        </Row>
                        { services.includes('one-id-ra') ?
                        <Row>
                          <Col className='align-self-center'>
                            เลือกรูปแบบการส่งข้อมูล :
                          </Col>
                          <Col className='align-self-center'>
                            {manageCheckbox()}
                          </Col>
                        </Row>
                        :
                          <></>
                        }
                        <Row>
                          <Col>
                            {manageImport()}
                          </Col>
                        </Row>
                      </Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        variant="outlined"
                        autoFocus
                        onClick={handleClose}
                        sx={{
                          color: `red`,
                          borderColor: `red`,
                        }}
                      >
                        ยกเลิก
                      </Button>
                      <Button variant="contained" autoFocus
                        onClick={() => {
                          if (file.length != 0) {
                            dispatch(setManageMemberStep({
                              manageMemberStep: 'add_member'
                            }))
                          } else {
                            message.error(`กรุณาเลือกไฟล์`);
                          }
                        }}
                        sx={!!style.primary_color && {
                          backgroundColor: `${style.secondary_color} !important`,
                          color: fontColor(style.secondary_color)
                        }}
                      >

                        อัปโหลด
                      </Button>
                    </DialogActions>
                  </BootstrapDialog>
                </Col>
              </Row>
              <Row>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary"
                        TabIndicatorProps={{
                          sx: !!style.secondary_color && {
                            backgroundColor: `${style.secondary_color} !important`,
                            color: fontColor(style.primary_color)
                          }
                        }}>
                        <Tab label="จัดการสมาชิก" value="1" />
                        {(currentRole === 'RA' || currentRole === 'owner') && <Tab label="ติดตามสมาชิก" value="2" />}
                        <Tab label="ประวัติการเพิ่ม" value="3" />
                         
                        {(services.includes('renew-ca')  && (currentRole === 'RA')) && <Tab label="ต่ออายุ CA" value="4" />} 
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <Member />
                    </TabPanel>
                    <TabPanel value="2">
                      <FollowMember />
                    </TabPanel>
                    <TabPanel value="3">
                      <AddHistory />
                    </TabPanel>
                    <TabPanel value="4">
                      <ReNewCA />
                    </TabPanel>
                  </TabContext>
                </Box>
              </Row>
            </>
          ),
          "add_member": (
            <>
              <AddMember
                backStep={() => {
                  dispatch(setManageMemberStep({
                    manageMemberStep: 'manage_member'
                  }))
                  setOpen(false);
                  dispatch(setFile({
                    file: [],
                    filename: '',
                    file_id: ''
                  }))
                  dispatch(setMemberFail({
                    member_fail: []
                  }))
                  dispatch(setMemberSuccess({
                    member_success: []
                  }))
                  setFormName(services.includes('one-id') || services.includes('one-id-pmuc') ? ['One ID'] : [''])
                  setCheckName(['user'])
                }}
                typeTemplate={formName}
              />
            </>
          ),
          "history_detail": (
            <HistoryDetail
              backStep={() => {
                setStep('manage_member')
              }}
            />
          )
        }[step]
      }
    </>
  );
}
export default ManageMember;